import Route from './content-studio-routes'

export { Route }
export default { Route }
